function Mauritius({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1620)">
  <path d="M1.94543 8.34781L16 9.73913L30.0545 8.34781C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94543 8.34781Z" fill="#D80027"/>
  <path d="M1.94544 23.6519L16 25.0432L30.0546 23.6519C31.2948 21.3787 32 18.7716 32 15.9997L16 14.6084L0 15.9997C0 18.7716 0.705188 21.3787 1.94544 23.6519Z" fill="#FFDA44"/>
  <path d="M1.94544 8.34766C0.705188 10.6208 0 13.228 0 15.9998H32C32 13.228 31.2948 10.6208 30.0546 8.34766H16H1.94544Z" fill="#0052B4"/>
  <path d="M16 32.0002C22.0647 32.0002 27.3409 28.6258 30.0545 23.6523H1.94543C4.65912 28.6258 9.93531 32.0002 16 32.0002Z" fill="#6DA544"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Mauritius;
